// extracted by mini-css-extract-plugin
export var loader = "loader-module--loader--3a9a4";
export var loader__absolute = "loader-module--loader__absolute--642c9";
export var spin = "loader-module--spin--e85c5";